export default function DSA_Linked_Lists_Operations() {
  return <div>DSA_Linked_Lists_Operations Component</div>;
}
